import React, { useState, useEffect, useRef } from 'react';
import PropTypes, { func } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Select, Button, Loader } from 'sa-ui';
import queryString from 'query-string';
import YearTabs from 'app/common/YearTabs';
import { promisify } from '../../app/actions';

import messages from './reportGeneralPanelMessages';
import * as actions from '../reportsActions';
import * as helpers from './reportGeneralPanelHelpers';

import ResultCard from '../ReportResultCard';
import Chart from '../ReportBarChart';
import ChartComparative from '../ReportBarChartComparative';
import ChartComparativeDisciplines from '../ReportBarChartComparativeDisciplines';
import RankingStudentCard from '../RankingStudentCard';
import GradeComparativeAbilitiesTable from '../GradeComparativeAbilitiesTable';
import LoadMore from '../LoadMore';

import './ReportGeneralPanelContainer.scss';

function getRankingLimitFromUrl() {
  const params = queryString.parse(window.location.search.replace('?', ''));
  return params.rankingLimit ? Number(params.rankingLimit) : undefined;
}

function getInitialComparative() {
  const params = queryString.parse(window.location.search.replace('?', ''));
  return params.comparative === 'true' ? true : false;
}

const ReportGeneralPanelContainer = (props) => {
  const [filter, setFilter] = useState(queryString.parse(window.location.search.replace('?', '')));
  const [rankingPage, setRankingPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [comparative, setComparative] = useState(getInitialComparative);

  const [totalStudents, setTotalStudents] = useState(0);
  const [avgHit, setAvgHit] = useState(0);
  const [avgErrors, setAvgErrors] = useState(0);

  const contractOptions = helpers.getContractOptions(props.groupsFilters);
  const applicationOptions = helpers.getApplicationOptions(props.groupsFilters, filter.idContract);

  const evaluationOptions = helpers.getEvaluationOptions(props.groupsFilters, filter.idApplication);
  // const levelOptions = helpers.getLevelOptions(props.groupsFilters, filter.idEvaluation);

  // const schoolOptions = helpers.getSchoolOptions(props.groupsFilters, filter.idApplication);
  if (filter.idEvaluation && filter.idEvaluation.includes(',')) {
    filter.idEvaluationAux = filter.idEvaluation.split(',')[0];
  } else {
    filter.idEvaluationAux = filter.idEvaluation;
  }
  const schoolOptions = helpers.getSchoolOptions(props.groupsFilters, filter.idEvaluationAux);
  const classesOptions = helpers.getClassOptions(
    props.groupsFilters,
    filter.idEvaluationAux,
    filter.idCSchool,
  );

  function buildRankingParams({ idContract, idApplication, idEvaluation, idCSchool, idESCourse, year: rankingYear }, page) {
    const rankingLimitFromUrl = getRankingLimitFromUrl();
    return {
      idContract,
      idApplication,
      idEvaluation,
      idCSchool,
      idESCourse,
      year: rankingYear,
      page,
      ...(rankingLimitFromUrl && { rankingLimit: rankingLimitFromUrl }),
    };
  }

  async function loadMoreRanking() {
    const nextPage = rankingPage + 1;
    setRankingPage(nextPage);
    await props.getESGradeByRankingStudent(
      buildRankingParams(
        {
          idContract: filter.idContract,
          idApplication: filter.idApplication,
          idEvaluation: filter.idEvaluation,
          idCSchool: filter.idCSchool,
          idESCourse: filter.idESCourse,
          year,
        },
        nextPage,
      ),
    );
  }

  async function selectContract(
    idContract,
    idApplication,
    idEvaluation,
    idCSchool,
    idESCourse,
    currentYear,
  ) {
    setFilter({ ...filter, idContract });
    setLoading(true);

    // if idEvaluation has a comma, it means that it is a comparative evaluation
    if (idEvaluation && idEvaluation.includes(',')) {
      setComparative(true);
      // convert string to array
      idEvaluation = idEvaluation.split(',');
    } else {
      setComparative(false);
    }

    console.log('URL COMPARATIVE', comparative);

    try {
      if (idContract && idApplication && !comparative) {
        if (!idCSchool) {
          await props.getESGradeGeneral({
            idContract,
            idApplication,
            idEvaluation,
            idESCourse,
            year: currentYear || year,
          });
        } else {
          await props.getESGradeGeneral({
            idCSchool,
            idApplication,
            idEvaluation,
            idESCourse,
            year: currentYear || year,
          });
        }
        setRankingPage(0);
        await props.getESGradeByRankingStudent(
          buildRankingParams(
            {
              idContract,
              idApplication,
              idEvaluation,
              idCSchool,
              idESCourse,
              year: currentYear || year,
            },
            0,
          ),
        );
        await props.getESGradeByDiscipline({
          idApplication,
          idEvaluation,
          idCSchool,
          idESCourse,
          year: currentYear || year,
        });
      } else if (idContract && idApplication && (comparative || params.comparative)) {
        await props.getESGradeComparativeGeneral({
          idContract,
          idApplication,
          idEvaluation,
          idCSchool,
          idESCourse,
          year: currentYear || year,
        });
        await props.getESGradeComparativeByDiscipline({
          idContract,
          idApplication,
          idEvaluation,
          idCSchool,
          idESCourse,
          year: currentYear || year,
        });
        await props.getESQuestionsDetailsByComparative({
          idContract,
          idApplication,
          idEvaluation,
          idCSchool,
          idESCourse,
          year: currentYear || year,
        });
      }
    } finally {
      setLoading(false);
    }
  }

  //

  async function handleGetGeneralPainelFilters() {
    setLoading(true);
    try {
      // await props.getGroups({ reportFilter: true });
      await props.getGeneralPainelFilters();
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    handleGetGeneralPainelFilters();
  }, []);

  useEffect(() => {
    if (props.years.length > 0) {
      setYears(props.years);
      setYear(props.years[0]);
    }
  }, [props.years]);

  useEffect(() => {
    setFilter({
      ...filter,
      idContract: props.contracts.length === 1 ? props.contracts[0].idContract : '',
    });
  }, [props.contracts]);

  useEffect(() => {
    if (
      filter.idContract ||
      filter.idApplication ||
      filter.idEvaluation ||
      filter.idCSchool ||
      filter.idESCourse
    ) {
      selectContract(
        filter.idContract,
        filter.idApplication,
        filter.idEvaluation,
        filter.idCSchool,
        filter.idESCourse,
      );
    }
  }, [
    filter.idCSchool,
    filter.idApplication,
    filter.idEvaluation,
    filter.idESCourse,
    filter.idContract,
  ]);

  useEffect(() => {
    if (
      Object.keys(props.generalReport).length > 0 &&
      props.ranking &&
      props.ranking.content &&
      props.ranking.content.length > 0 &&
      !comparative
    ) {
      setTimeout(() => {
        // sinaliza para o puppeteer renderizar pdf
        window.dispatchEvent(new CustomEvent('app-ready'));
      });
    }
  }, [props.generalReport, props.ranking]);

  useEffect(() => {
    if (
      Object.keys(props.generalComparativeReport).length > 0 &&
      props.questionsDetailsComparativeReport &&
      props.questionsDetailsComparativeReport.length > 0 &&
      comparative
    ) {
      setTimeout(() => {
        // sinaliza para o puppeteer renderizar pdf
        window.dispatchEvent(new CustomEvent('app-ready'));
      });
    }
  }, [props.generalComparativeReport, props.questionsDetailsComparativeReport]);

  async function generatePdf() {
    setLoading(true);
    try {
      await props.generatePdf({
        filename: `${props.intl.formatMessage(messages.title)}.pdf`,
        host: `${window.location.protocol}//${window.location.host}`,
        path: window.location.pathname,
        params: { ...filter, rankingLimit: 100, expanded: true, comparative: comparative },
        token: props.token,
      });
    } finally {
      setLoading(false);
    }
  }

  function goBack() {
    props.history.goBack();
  }

  function handleChangeContract(event) {
    setFilter({
      ...filter,
      idContract: event.target.value,
      idApplication: undefined,
      idEvaluation: undefined,
      idCSchool: undefined,
      idESCourse: undefined,
    });
  }

  function handleChangeApplication(event) {
    const application = applicationOptions.find((el) => el.value === event.target.value);
    setYears([application.year]);
    setYear(application.year);
    setFilter({
      ...filter,
      idApplication: event.target.value,
      idEvaluation: undefined,
      idCSchool: undefined,
      idESCourse: undefined,
    });
  }

  function handleChangeEvaluation(event) {
    const value = event.target.value;
    let evaluation;

    if (value.includes(',')) {
      // const searchValues = value.split(',');

      // const findMatchingEntry = (searchValues, dataArray) => {
      //   return dataArray.find(
      //     (entry) =>
      //       entry.value.length === searchValues.length &&
      //       entry.value.every((val, index) => val === searchValues[index]),
      //   );
      // };

      // evaluation = findMatchingEntry(searchValues, evaluationOptions);
      setComparative(true);
    } else {
      setComparative(false);
    }

    evaluation = evaluationOptions.find((el) => el.value.includes(value));

    setYears([evaluation.year]);
    setYear(evaluation.year);
    setFilter({
      ...filter,
      idEvaluation: value,
      idCSchool: undefined,
      idESCourse: undefined,
    });
  }

  // function handleChangeLevel(event) {
  //   const level = levelOptions.find((el) => el.value === event.target.value);
  //   setYears([level.year]);
  //   setYear(level.year);
  //   setFilter({
  //     ...filter,
  //     idLevel: event.target.value,
  //     idCSchool: undefined,
  //     idESCourse: undefined,
  //   });
  // }

  function handleChangeSchool(event) {
    const school = schoolOptions.find((el) => el.value === event.target.value);
    setYears([school.year]);
    setYear(school.year);
    setFilter({ ...filter, idCSchool: event.target.value, idESCourse: undefined });
  }

  function handleChangeCourse(event) {
    setFilter({ ...filter, idESCourse: event.target.value });
  }

  async function handleChangeFilter(currentYear) {
    setYear(currentYear);
    selectContract(
      filter.idContract,
      filter.idApplication,
      filter.idEvaluation,
      filter.idCSchool,
      filter.idESCourse,
      currentYear,
    );
  }

  useEffect(() => {
    if (comparative && Object.keys(props.generalComparativeReport).length > 0) {
      setTotalStudents(props.generalComparativeReport.totalStudents);
      setAvgHit(props.generalComparativeReport.avgHit);
      setAvgErrors(props.generalComparativeReport.avgErrors);
    } else if (!comparative && Object.keys(props.generalReport).length > 0) {
      setTotalStudents(props.generalReport.totalStudents);
      setAvgHit(props.generalReport.avgHit);
      setAvgErrors(props.generalReport.avgErrors);
    }
  }, [props.generalReport, props.generalComparativeReport]);

  return (
    <div className="report-general-panel">
      <Loader show={loading} />
      <Row className="align-items-end d-print-none">
        <Col md={12}>
          <a className="return" onClick={goBack}>
            <i className="ti-arrow-left" />
            {props.intl.formatMessage(messages.back)}
          </a>
          <h5 className="title">{props.intl.formatMessage(messages.title)}</h5>
        </Col>
      </Row>
      <hr className="d-print-none" />
      <Row className="align-items-center d-print-none">
        <Col md={6} className="column-contract">
          {props.contracts.length === 1 && (
            <div className="contract-info">
              <div className="contract-logo">
                {helpers.getInitials(props.contracts[0].contractName)}
              </div>
              <span className="contract-name">{props.contracts[0].contractName}</span>
            </div>
          )}
          {props.contracts.length > 1 && (
            <Select
              containerClassName="mt-0"
              nullable
              onChange={handleChangeContract}
              options={contractOptions}
              placeholder={props.intl.formatMessage(messages.chain)}
            />
          )}
        </Col>
        <Col md={6} className="column-filters">
          <Select
            containerClassName="mt-0"
            disabled={!filter.idContract}
            nullable
            name="idApplication"
            onChange={handleChangeApplication}
            value={filter.idApplication}
            options={applicationOptions}
            placeholder={props.intl.formatMessage(messages.application)}
          />
        </Col>
      </Row>
      <Row className="mt-3 align-items-center d-print-none">
        <Col md={12} className="column-filters">
          <Select
            containerClassName="mt-0"
            disabled={!filter.idApplication}
            nullable
            name="idEvaluation"
            onChange={handleChangeEvaluation}
            value={filter.idEvaluation}
            options={evaluationOptions}
            placeholder={`${props.intl.formatMessage(
              messages.evaluation,
            )}/${props.intl.formatMessage(messages.level)}/${props.intl.formatMessage(
              messages.book,
            )}`}
          />
        </Col>
      </Row>
      <Row className="mt-3 align-items-center d-print-none">
        <Col md={6} className="column-filters">
          <Select
            containerClassName="mt-0"
            disabled={!filter.idEvaluation}
            nullable
            name="idCSchool"
            onChange={handleChangeSchool}
            value={filter.idCSchool}
            options={schoolOptions}
            placeholder={props.intl.formatMessage(messages.school)}
          />
        </Col>
        <Col md={6} className="column-filters">
          <Select
            containerClassName="mt-0"
            disabled={!filter.idCSchool}
            nullable
            name="idESCourse"
            value={filter.idESCourse}
            onChange={handleChangeCourse}
            options={classesOptions}
            placeholder={props.intl.formatMessage(messages.class)}
          />
        </Col>
      </Row>
      <Row>
        <Col
          md={12}
          className="d-flex justify-content-end column-filters"
          style={{ marginTop: '20px' }}
        >
          <Button primary className="small-button" onClick={generatePdf}>
            {props.intl.formatMessage(messages.generatePdf)}
          </Button>
        </Col>
      </Row>
      {years.length > 0 && filter.idContract && filter.idApplication ? (
        <div className="d-print-none">
          <YearTabs
            year={year}
            years={years}
            onChangeYear={(year) => handleChangeFilter(year)}
            hidePages
          />
        </div>
      ) : (
        <hr className="d-print-none" />
      )}

      <div id="divToPDF" className="divToPDF">
        <Row>
          <Col md={12}>
            <Row>
              <Col xs={6} md={6} lg={6} xl={4}>
                <ResultCard
                  label={props.intl.formatMessage(messages.totalStudents)}
                  value={totalStudents}
                />
              </Col>
              <Col xs={6} md={6} lg={6} xl={4}>
                <ResultCard
                  label={props.intl.formatMessage(messages.averageHits)}
                  value={`${avgHit}%`}
                />
              </Col>
              <Col xs={6} md={6} lg={6} xl={4}>
                <ResultCard
                  label={props.intl.formatMessage(messages.averageErrors)}
                  value={`${avgErrors}%`}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        {!comparative ? (
          <div>
            {Object.keys(props.generalReport).length > 0 && (
              <div>
                {!filter.idCSchool ? (
                  <Row className="mt-3">
                    <Col md={12}>
                      <Chart
                        schools={props.generalReport.schools}
                        title={props.intl.formatMessage(messages.generalPerformance)}
                      />
                    </Col>
                  </Row>
                ) : (
                  <div>
                    <Row className="mt-3">
                      <Col md={12}>
                        <Chart
                          schools={props.generalReport.courses}
                          title={props.intl.formatMessage(messages.generalPerformanceByClass)}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
                {filter.idEvaluation && (
                  <Row className="mt-3">
                    <Col md={12}>
                      <Chart
                        schools={props.disciplines}
                        title={props.intl.formatMessage(messages.generalPerformanceByComponent)}
                      />
                    </Col>
                  </Row>
                )}
              </div>
            )}
            {props.ranking &&
              props.ranking.content &&
              props.ranking.content.length > 0 && (
              <div>
                <div>
                  <h5 className="title">{props.intl.formatMessage(messages.studentsRanking)}</h5>
                </div>
                <div>
                  <Row>
                    <Col md={12}>
                      {props.ranking.content.map((student) => (
                        <Row className="align-items-center avoid-page-break" key={student.position}>
                          <Col style={{ width: 40 }} md="auto">
                            {student.position}º
                          </Col>
                          <Col>
                            <RankingStudentCard
                              initials={student.studentInitials}
                              percentage={student.percentHits}
                              studentName={student.studentName}
                              studentInfo={`${student.courseName} | ${student.schoolName}`}
                              index={student.position}
                            />
                          </Col>
                        </Row>
                      ))}
                      <hr className="my-3 d-print-none" />
                      {rankingPage + 1 < props.ranking.totalpages && (
                        <div className="d-print-none">
                          <LoadMore onClick={loadMoreRanking} />
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div>
            <Row className="mt-3">
              <Col md={12}>
                {Object.keys(props.generalComparativeReport).length > 0 && (
                  <ChartComparative
                    generalComparativeReport={props.generalComparativeReport}
                    title={props.intl.formatMessage(messages.generalPerformanceComparative)}
                  />
                )}
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={12}>
                <ChartComparativeDisciplines
                  courses={
                    props.disciplineComparativeReport.length > 0
                      ? props.disciplineComparativeReport[0].courses
                      : []
                  }
                  title={props.intl.formatMessage(
                    messages.generalPerformanceComparativeCurricularComponent,
                  )}
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <GradeComparativeAbilitiesTable
                  // idEvaluation={props.idEvaluation}
                  data={props.questionsDetailsComparativeReport}
                  limit={10}
                />
              </Col>
            </Row>
          </div>
        )}
      </div>
    </div>
  );
};

ReportGeneralPanelContainer.propTypes = {};

const mapStateToProps = ({ reports, app }) => ({
  ...reports,
  token: app.cookieToken,
  permission: app.isCoordinator,
});

export default compose(
  injectIntl,
  withRouter,
  connect(
    mapStateToProps,
    promisify(
      { ...actions },
      {
        include: [
          'generatePdf',
          // 'getGroups',
          'getGeneralPainelFilters',
          'getESGradeGeneral',
          'getESGradeByRankingStudent',
          'getESGradeByDiscipline',
          'getESGradeComparativeByDiscipline',
          'getESGradeComparativeGeneral',
          'getESQuestionsDetailsByComparative',
        ],
      },
    ),
  ),
)(ReportGeneralPanelContainer);
